import uuid from "uuid";
import { Storage } from "aws-amplify";

export async function s3Upload(file) {
  var ext = "";
  var lastIndex = file.name.lastIndexOf(".");
  if (lastIndex > 0) {
    ext = file.name.substr(lastIndex);
  }
  const filename = `${uuid.v1()}${ext}`





  const stored = await Storage.put(filename, file, {
    contentType: file.type
  });

  return stored.key;
}
export async function s3UploadBlob(orgId, file, blob) {
  var ext = "";
  var lastIndex = file.name.lastIndexOf(".");
  if (lastIndex > 0) {
    ext = file.name.substr(lastIndex);
  }
//ACL: 'public-read'
  const filename = `${uuid.v1()}${ext}`
  const fullPath = `${orgId}${'/icons/'}${filename}`
  const stored = await Storage.put(fullPath, blob, {
    contentType: file.type, ACL: 'public-read'
  });
  return stored.key;
}



// WEBPACK FOOTER //
// ./src/libs/awsLib.js